<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'LabDipRequests_Title' | translateWF: 'Lab Dip Requests' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'LabDipRequests_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="cs-page-list-grid">
        @if (filterConfig() && showFilters()) {
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        }

        <p-panel [header]="'LabDipRequests_Title' | translateWF: 'Lab Dip Requests'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>
          <p-card data-variant="compact">
            <p-table [value]="listLabDipRequests()" dataKey="id" selectionMode="single" (onSort)="onSort($event)" [lazy]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="requestNumber">
                    {{ 'LabDipRequests_Request' | translateWF: 'Request' }}
                    <p-sortIcon field="requestNumber" />
                  </th>
                  <th>
                    {{ 'LabDipRequests_Username' | translateWF: 'Username' }}
                  </th>
                  <th class="w-[160px]">
                    {{ 'LabDipRequests_Client' | translateWF: 'Client' }}
                  </th>
                  <th class="w-[160px]">
                    {{ 'LabDipRequests_Brand' | translateWF: 'Brand' }}
                  </th>
                  <th>
                    {{ 'LabDipRequests_Fabric_Code' | translateWF: 'Fabric Code' }}
                  </th>
                  <th>
                    {{ 'LabDipRequests_Colors' | translateWF: 'Colors' }}
                  </th>
                  <th>
                    {{ 'LabDipRequests_ProductDev' | translateWF: 'Product Dev' }}
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                @let labDipRequest = getRowData(rowData);
                <tr class="cursor-pointer" (click)="redirectToDetails(labDipRequest.id)">
                  <td>
                    <a>
                      {{ labDipRequest.requestNumber }}
                    </a>
                  </td>
                  <td>{{ labDipRequest.createdByName || labDipRequest.createdBy }}</td>
                  <td class="truncate max-w-[160px]" [pTooltip]="labDipRequest.clientName || labDipRequest.customerReference">
                    {{ labDipRequest.clientName || labDipRequest.customerReference }}
                  </td>
                  <td class="truncate max-w-[160px]" [pTooltip]="labDipRequest.brandName || labDipRequest.brandReference || ''">
                    {{ labDipRequest.brandName || labDipRequest.brandReference }}
                  </td>
                  <td>{{ labDipRequest.longDescription }}</td>
                  <td>{{ getColorsString(labDipRequest.colors) }}</td>
                  <td>
                    <i *ngIf="labDipRequest.isForProductDevelopment" class="pi pi-check text-green-500"></i>
                    <i *ngIf="!labDipRequest.isForProductDevelopment" class="pi pi-times text-red-500"></i>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">
                    {{ 'LabDipRequests_Not_Found' | translateWF: 'Lab Dip Requests not found' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <p-paginator
              [rows]="pageSize()"
              [totalRecords]="totalRecords()"
              [first]="(currentPage() - 1) * pageSize()"
              (onPageChange)="onPageChange($event)"
              [rowsPerPageOptions]="[15, 25, 50]"
              class="mt-4"
            />
          </p-card>
        </p-panel>
      </div>
    </section>
  </div>
</main>
